import React from 'react';
import PropTypes from 'prop-types';
import { LinkButton } from '@ui/button';
import { useReporter } from '../../reporter';
import { addPetClicked } from './events';

export const AddPupButton = ({
  href,
  fullWidth = false,
  variant,
  verticalPadding,
  horizontalPadding,
  minWidth = 122,
  text,
}) => {
  const reporter = useReporter();
  const addIcon = {
    size: '18px',
    iconName: 'plus',
    alt: 'add icon',
    color: 'hero.plum',
    position: 'before',
  };
  const onClickAdd = () => {
    reporter.tag(addPetClicked());
  };
  return (
    <LinkButton
      href={href}
      icon={addIcon}
      fullWidth={fullWidth}
      onClick={onClickAdd}
      variant={variant}
      verticalPadding={verticalPadding}
      horizontalPadding={horizontalPadding}
      minWidth={minWidth}
    >
      {text}
    </LinkButton>
  );
};

AddPupButton.displayName = 'AddPupButton';
AddPupButton.propTypes = {
  href: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
  variant: PropTypes.string.isRequired,
  verticalPadding: PropTypes.number.isRequired,
  horizontalPadding: PropTypes.number.isRequired,
  minWidth: PropTypes.number,
  text: PropTypes.string.isRequired,
};
